module.exports = __webpack_public_path__ + "static/melissa-seidemann-pool-5e4d1cb5814fbae2add597e87ddb36f8.jpg";